<template>
  <v-sheet
      v-if="!$tools.isEmpty(text) && text.length>width*0.138"
      :width="width" :height="height"
      color="transparent"
      class="d-inline-block"
      :style="'padding: '+(height*0.2)+'px 0'"
  >
    <v-row no-gutters>
      <v-col>
        <v-sheet :width="width-24" color="transparent" class="text-no-wrap text-overflow">
          {{text}}
        </v-sheet>
      </v-col>
      <v-col v-if="!$tools.isEmpty(text) && text.length>width*0.138" cols="auto">
        <tooltip-view bottom>
          <template v-slot:action>
            <v-icon small class="ml-2">mdi-information-outline</v-icon>
          </template>
          <template v-slot:content>
            <div class="caption pb-2" v-html="$tools.nl2br(text)"></div>
          </template>
        </tooltip-view>
      </v-col>
    </v-row>
  </v-sheet>
  <div v-else class="d-inline-block">
    {{text}}
  </div>
</template>

<script>

import TooltipView from "@/components/TooltipView.vue";

export default {
  components: {TooltipView},
  props:['text','width','height'],
}
</script>